import cn from 'classnames';
import { FormattedMessage } from 'react-intl';

import { Avatar } from '@/shared/ui';

import styles from './OrganizationRow.module.scss';

type RowProps = {
  organizationName: string;
  initials: string;
  avatarSrc: string;
  isCurrentOrganization?: boolean;
  isMFARequired?: boolean;
};

export const Row = (props: RowProps) => {
  const {
    organizationName,
    avatarSrc,
    initials,
    isCurrentOrganization,
    isMFARequired,
  } = props;

  return (
    <div className={styles.info}>
      <Avatar src={avatarSrc} alt={organizationName} initials={initials} />

      <div className={styles.details}>
        <p className="p2">
          {organizationName}{' '}
          {isCurrentOrganization && (
            <FormattedMessage
              id="controlPanel.myClinics.current"
              defaultMessage="(current)"
            />
          )}
        </p>

        {isMFARequired && (
          <span className={cn(styles.mfaMarker, 'p4b')}>
            <FormattedMessage
              id="controlPanel.myClinics.codeRequired"
              defaultMessage="Code required"
            />
          </span>
        )}
      </div>
    </div>
  );
};
